module.exports = __webpack_public_path__ + "images/greyStar59772e041ff315046eb857d16032ad74.png";